import React, { useState } from "react";
import floraKartIcon from "../assets/logo.jpg";
import HomeRoundedIcon from "@material-ui/icons/HomeRounded";
import ShoppingCartRoundedIcon from "@material-ui/icons/ShoppingCartRounded";
import BookmarksRoundedIcon from "@material-ui/icons/BookmarksRounded";
import WatchLaterRoundedIcon from "@material-ui/icons/WatchLaterRounded";
import AccountCircleRoundedIcon from "@material-ui/icons/AccountCircleRounded";
import { NavLink, useHistory } from "react-router-dom";
import defaultImage from "../assets/default.jpg";
import ReactTooltip from "react-tooltip";
import { useStateValue } from "../context/StateProvider";
import "./Sidebar.scss";

const iconStyle = (fontsize) => {
  return {
    fill: "transparent",
    stroke: "#1a1a2c",
    strokeWidth: 1,
    fontSize: fontsize,
  };
};

function Sidebar() {
  const history = useHistory();
  const [{ user, cart, wishlist }, dispatch] = useStateValue();
  const [sidebarActive, setSidebarActive] = useState(false);
  const toggleSidebar = () =>
    setSidebarActive((sidebarActive) => !sidebarActive);
  const handleCategory = () => {
    dispatch({
      type: "SET_CATEGORY",
      category: "all",
    });
    toggleSidebar();
  };
  return (
    <div className={`sidebar ${sidebarActive ? "active" : ""}`}>
      <img
        src={floraKartIcon}
        className="sidebar__icon"
        onClick={toggleSidebar}
        alt="floraKart"
      />
      <div className="sidebar__menu">
        <NavLink
          to="/"
          exact
          className="sidebar__menuItem"
          activeClassName="active"
          data-tip="Home"
          data-for="sidebarTooltip"
          onClick={handleCategory}
        >
          <HomeRoundedIcon
            className="sidebar__menuIcon"
            style={iconStyle(36)}
          />
        </NavLink>
        <NavLink
          to="/cart"
          className="sidebar__menuItem"
          activeClassName="active"
          data-tip="Cart"
          data-for="sidebarTooltip"
          onClick={toggleSidebar}
        >
          <ShoppingCartRoundedIcon
            className="sidebar__menuIcon"
            style={iconStyle(34)}
          />
          <span className="sidebar__itemValue">{cart?.length || 0}</span>
        </NavLink>
        <NavLink
          to="/wishlist"
          className="sidebar__menuItem"
          activeClassName="active"
          data-tip="wishlist"
          data-for="sidebarTooltip"
          onClick={toggleSidebar}
        >
          <BookmarksRoundedIcon
            className="sidebar__menuIcon"
            style={iconStyle(30)}
          />
          <span className="sidebar__itemValue">{wishlist?.length || 0}</span>
        </NavLink>
        <NavLink
          to="/orders"
          className="sidebar__menuItem"
          activeClassName="active"
          data-tip="Orders"
          data-for="sidebarTooltip"
          onClick={toggleSidebar}
        >
          <WatchLaterRoundedIcon
            className="sidebar__menuIcon"
            style={iconStyle(32)}
          />
        </NavLink>
      </div>
      {user ? (
        <img
          src={user?.photoURL || defaultImage}
          onClick={() => {
            history.push("/profile");
            toggleSidebar();
          }}
          data-tip="My Account"
          data-for="sidebarTooltip"
          className="sidebar__avatar"
          alt=""
        />
      ) : (
        <NavLink
          to="/login"
          className="sidebar__menuItem"
          activeClassName="active"
          data-tip="Login / Register"
          data-for="sidebarTooltip"
          onClick={toggleSidebar}
        >
          <AccountCircleRoundedIcon
            className="sidebar__menuIcon"
            style={iconStyle(36)}
          />
        </NavLink>
      )}
      <ReactTooltip
        place="right"
        className="app__toolTip"
        id="sidebarTooltip"
        backgroundColor="#1a1a2cee"
        effect="solid"
      />
    </div>
  );
}
export default Sidebar;
